import React, { useState, useEffect, useCallback } from 'react';
import { Formik, Form } from 'formik';
import { css } from '@emotion/core';
import ClipLoader from 'react-spinners/ClipLoader';
import Select from 'react-select';
import { FaChevronRight } from 'react-icons/fa';
import { FiExternalLink } from 'react-icons/fi';
import { toast } from 'react-toastify';

import * as api from '~/Services/Service';
import EscalaSatisfacao from '~/Components/EscalaSatisfacao/EscalaSatisfacao';
import * as constants from '~/constant';
import { format } from '~/Utils/Helpers';
import Header from '~/Components/Header/Header';
import { gerarAmbienteUrl } from '../Vendas/helpers';
import { Button, Row } from 'react-bootstrap';
import { BsCheck, BsPencil } from 'react-icons/bs';
import { useSelector, useDispatch } from 'react-redux';
import CamposEndereco from '~/Components/Prospectos/ProspectoDetalhes/CamposEndereco/CamposEndereco';
import { getAtualizarCidades } from '~/Store/Prospecto/actions';
import Loading from '~/Components/Loading';

export default function PesquisaPosVenda(props) {
  const [dadosDaVenda, setDadosDaVenda] = useState({});
  const [questionario, setQuestionario] = useState([]);
  const [formEndereco, setFormEndereco] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isConfirmandoEndereco, setIsConfirmandoEndereco] = useState(false);
  const options = useSelector(state => state.options);

  const dispatch = useDispatch();
  const atualizarCidades = useCallback(
    uf => dispatch(getAtualizarCidades(uf)),
    [dispatch]
  );
  useEffect(() => {
    if (formEndereco && dadosDaVenda && dadosDaVenda.estado) {
      dispatch(getAtualizarCidades(dadosDaVenda.estado));
    }
  }, [formEndereco]);

  const salvarEnderecoProspecto = async (values, actions) => {
    try {
      actions.setSubmitting(true);
      const codigoProspecto = dadosDaVenda.codigo_prospecto;
      const prospectoCompleto = await api.getProspecto(codigoProspecto);
      const onlyDigits = s => (s || '').replace(/\D/g, '');
      const cidadeCodigo =
        values.codigo_cidade || prospectoCompleto.codigo_cidade || null;
      const cidadeDescricao =
        cidadeCodigo && options.cidadesById && options.cidadesById[cidadeCodigo]
          ? options.cidadesById[cidadeCodigo].descricao
          : dadosDaVenda.cidade;
      const request = {
        ...prospectoCompleto,
        cep: onlyDigits(values.cep),
        estado: values.estado,
        codigo_cidade: cidadeCodigo,
        bairro: values.bairro,
        endereco: values.endereco,
        numero: values.numero,
        complemento: values.complemento,
      };
      await api.atualizarProspecto(request);
      setDadosDaVenda(prev => ({
        ...prev,
        cep: values.cep,
        estado: values.estado,
        cidade: cidadeDescricao || prev.cidade,
        bairro: values.bairro,
        endereco: values.endereco,
        numero: values.numero,
        complemento: values.complemento,
      }));
      setFormEndereco(false);
      toast.success('Endereço atualizado');
    } catch (error) {
      console.error(error);
      toast.error('Erro ao atualizar endereço do prospecto');
    } finally {
      actions.setSubmitting(false);
    }
  };

  const buscarDadosCliente = async () => {
    const { codigo_boleto } = props.match.params;
    setIsLoading(true);
    let response = await api.getPesquisaPosVenda(codigo_boleto);
    setDadosDaVenda(response);
    setIsLoading(false);
  };

  const buscarQuestionario = async () => {
    let response = await api.getQuestionarioPosVenda();
    setQuestionario(response);
  };

  const REGRAS_CONDICIONAIS_PERGUNTAS = {
    76: {
      condicao: () => dadosDaVenda.primeiro_contrato,
      descricao: 'Pergunta sobre conhecer Setpar antes da compra',
    },
    120: {
      perguntaDependente: 119,
      condicao: resposta => resposta !== 10,
      descricao: 'Pergunta sobre melhorias quando nota < 10',
    },
    122: {
      perguntaDependente: 117,
      condicao: resposta => resposta === 598,
      descricao: 'Campo texto para "Outro" da pergunta 117',
    },
    124: {
      perguntaDependente: 123,
      condicao: resposta => resposta === 604,
      descricao: 'Campo texto para "Outro" da pergunta 123',
    },
  };

  const obterRespostaPergunta = codigoPergunta => {
    return dadosDaVenda.respostas
      ? dadosDaVenda.respostas.find(
          resp => resp.codigo_pergunta === codigoPergunta
        )
      : null;
  };

  const mostrarPergunta = (codigo_pergunta, values) => {
    const regra = REGRAS_CONDICIONAIS_PERGUNTAS[codigo_pergunta];

    if (!regra) return true;

    if (!regra.perguntaDependente) {
      return regra.condicao();
    }

    if (isRespondido) {
      const resposta = obterRespostaPergunta(regra.perguntaDependente);
      return resposta ? regra.condicao(resposta.codigo_resposta) : false;
    } else {
      const valorAtual = values && values[regra.perguntaDependente];
      return valorAtual !== undefined ? regra.condicao(valorAtual) : false;
    }
  };

  useEffect(() => {
    buscarDadosCliente();
    buscarQuestionario();
  }, []);

  const salvarPesquisa = async (values, actions) => {
    try {
      let respostas = [];
      values.forEach(function(element, index) {
        if (element) {
          if (typeof element == 'string')
            respostas.push({
              codigo_pergunta: index,
              codigo_resposta: 0,
              dissertativa: element,
            });
          else
            respostas.push({
              codigo_pergunta: index,
              codigo_resposta: element,
              dissertativa: null,
            });
        }
      });

      if (respostas.length < QTD_PERGUNTAS_OBRIGATORIAS) {
        toast.warning(
          'Por favor, verifique se preencheu todos os campos antes de enviar.'
        );
        actions.setSubmitting(false);
        return;
      }

      const response = await api.salvarPesquisaPosVenda(
        respostas,
        dadosDaVenda.codigo_boleto
      );
      if (response.success) toast.success('Pesquisa salva com sucesso');
      else toast.warning('A pesquisa já foi salva posteriormente');
      actions.setSubmitting(false);
      buscarDadosCliente();
    } catch (error) {
      toast.error('Erro ao salvar a pesquisa. Tente novamente');
      actions.setSubmitting(false);
    }
  };

  const isRespondido =
    dadosDaVenda.respostas && dadosDaVenda.respostas.length > 0;

  const QTD_PERGUNTAS_OBRIGATORIAS =
    questionario && questionario.filter(item => item.obrigatoria).length;

  const obterValorPadrao = (pergunta, tipo_pergunta) => {
    const ultimaRespostaCliente = dadosDaVenda.respostas
      ? dadosDaVenda.respostas.filter(value => {
          return value.codigo_pergunta === pergunta;
        })
      : [];

    if (ultimaRespostaCliente.length === 0) return undefined;

    const {
      codigo_resposta,
      dissertativa,
      descricao,
    } = ultimaRespostaCliente[0];

    switch (tipo_pergunta) {
      case constants.TIPOS_PESQUISA.ESCOLHA:
        return { value: codigo_resposta, label: descricao };
      case constants.TIPOS_PESQUISA.PESO:
        return codigo_resposta;
      case constants.TIPOS_PESQUISA.DISSERTATIVA:
        return dissertativa;
      default:
        return;
    }
  };

  if (isLoading) return <Loading />;

  return (
    <>
      <Header title="Pesquisa Pós-venda" />
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 col-md-6 mx-auto">
            <div className="card border-0">
              <div className="card-body">
                {dadosDaVenda && (
                  <>
                    <div className="tri-empreendimento-imob-corretor">
                      <div className="logo-emprendimento-pesquisa">
                        <img
                          alt={dadosDaVenda.empreendimento}
                          src={dadosDaVenda.url_logo_empreendimento}
                        />
                      </div>
                      <FaChevronRight />
                      <div className="logo-imobiliaria-pesquisa">
                        <img
                          alt={dadosDaVenda.imobiliaria}
                          src={dadosDaVenda.url_logo_imobiliaria}
                        />
                      </div>
                      <FaChevronRight />
                      <div className="foto-corretor-pesquisa">
                        <img
                          alt={dadosDaVenda.nome_corretor}
                          src={dadosDaVenda.url_foto_corretor}
                        />
                      </div>
                    </div>
                    <div className="dados-pesquisa-posvenda">
                      <ul className="list-unstyled d-flex flex-wrap produtividade text-md-left df-center mt-3">
                        <li>
                          <small className="d-block">Empreendimento</small>
                          <strong className="d-block">
                            {dadosDaVenda.empreendimento}
                          </strong>
                        </li>
                        <li>
                          <small className="d-block">Imobiliaria</small>
                          <strong className="d-block">
                            {dadosDaVenda.nome_imobiliaria}
                          </strong>
                        </li>
                        <li>
                          <small className="d-block">Corretor</small>
                          <strong className="d-block">
                            {dadosDaVenda.nome_corretor}
                          </strong>
                        </li>
                      </ul>
                      <ul className="list-unstyled d-flex flex-wrap produtividade text-md-left df-center my-3">
                        <li>
                          <small className="d-block">Quadra</small>
                          <strong className="d-block">
                            {dadosDaVenda.quadra}
                          </strong>
                        </li>
                        <li>
                          <small className="d-block">Lote</small>
                          <strong className="d-block">
                            {dadosDaVenda.lote}
                          </strong>
                        </li>
                        <li>
                          <small className="d-block">Pré-venda</small>
                          <strong className="d-block">
                            {dadosDaVenda.pre_venda}
                          </strong>
                        </li>
                        <li>
                          <small className="d-block">Data da Venda</small>
                          <strong className="d-block">
                            {format.date(dadosDaVenda.data_venda)}
                          </strong>
                        </li>
                      </ul>
                      <hr />
                      <ul className="list-unstyled d-flex flex-wrap produtividade text-md-left df-center">
                        <li>
                          <small className="d-block">Nome do cliente</small>
                          <strong className="d-block">
                            <a
                              href={
                                `${gerarAmbienteUrl(false)}/prospectos/lista/` +
                                dadosDaVenda.codigo_prospecto
                              }
                              target="_blank"
                              rel="noreferrer noopener"
                            >
                              {dadosDaVenda.name_cliente}{' '}
                              <FiExternalLink className="align-icon-link" />
                            </a>
                          </strong>
                        </li>
                        <li>
                          <small className="d-block">E-mail</small>
                          <strong className="d-block">
                            {dadosDaVenda.email}
                          </strong>
                        </li>
                      </ul>
                      <ul className="list-unstyled d-flex flex-wrap produtividade text-md-left df-center my-3">
                        <li>
                          <small className="d-block">Celular</small>
                          <strong className="d-block">
                            {dadosDaVenda.celular
                              ? format.celular(dadosDaVenda.celular)
                              : '-'}
                          </strong>
                        </li>
                        <li>
                          <small className="d-block">Tel. Residencial</small>
                          <strong className="d-block">
                            {dadosDaVenda.tel_residencial
                              ? format.celular(dadosDaVenda.tel_residencial)
                              : '-'}
                          </strong>
                        </li>
                        <li>
                          <small className="d-block">Tel. Comercial</small>
                          <strong className="d-block">
                            {dadosDaVenda.tel_comercial
                              ? format.celular(dadosDaVenda.tel_comercial)
                              : '-'}
                          </strong>
                        </li>
                      </ul>
                      <ul className="list-unstyled d-flex flex-wrap produtividade text-md-left df-center mt-3">
                        <li>
                          <small className="d-block">Endereço</small>
                          <strong className="d-block">
                            {dadosDaVenda.endereco} - {dadosDaVenda.bairro},{' '}
                            {dadosDaVenda.cidade} - {dadosDaVenda.estado},{' '}
                            {dadosDaVenda.cep
                              ? format.cep(dadosDaVenda.cep)
                              : '-'}
                          </strong>
                        </li>
                      </ul>
                      <div className="d-flex flex-wrap gap-2 justify-content-end mt-2">
                        {!dadosDaVenda.endereco_confirmado ? (
                          <Button
                            onClick={async () => {
                              try {
                                setIsConfirmandoEndereco(true);
                                await api.confirmarEnderecoProspecto(
                                  dadosDaVenda.codigo_prospecto
                                );
                                setFormEndereco(false);
                                setDadosDaVenda({
                                  ...dadosDaVenda,
                                  endereco_confirmado: true,
                                });
                                toast.success('Endereço confirmado com sucesso');
                              } catch (error) {
                                console.error(error);
                                toast.error('Erro ao confirmar endereço');
                              } finally {
                                setIsConfirmandoEndereco(false);
                              }
                            }}
                            className="me-3"
                            variant="outline-success"
                            disabled={isConfirmandoEndereco}
                          >
                            <BsCheck />
                            {isConfirmandoEndereco ? 'Confirmando...' : 'Confirmar'}
                          </Button>
                        ) : (
                          <p className="text-success mt-3 mx-2">
                            Endereço confirmado {'  '}
                          </p>
                        )}
                        <Button
                          onClick={() => setFormEndereco(true)}
                          className="me-3"
                          variant="outline-primary"
                        >
                          <BsPencil />
                          Editar endereço
                        </Button>
                      </div>
                      {formEndereco && (
                        <div className="px-3">
                          <Formik
                            enableReinitialize
                            initialValues={{
                              cep: dadosDaVenda.cep || '',
                              estado: dadosDaVenda.estado || '',
                              cidade: dadosDaVenda.cidade || '',
                              codigo_cidade: '',
                              bairro: dadosDaVenda.bairro || '',
                              endereco: dadosDaVenda.endereco || '',
                              numero: dadosDaVenda.numero || '',
                              complemento: dadosDaVenda.complemento || '',
                            }}
                            onSubmit={(values, actions) => {
                              salvarEnderecoProspecto(values, actions);
                            }}
                          >
                            {({
                              values,
                              errors,
                              touched,
                              handleChange,
                              handleBlur,
                              setFieldValue,
                              setValues,
                              handleSubmit,
                              isSubmitting,
                            }) => (
                              <>
                                <CamposEndereco
                                  getAtualizarCidades={atualizarCidades}
                                  options={options}
                                  handleBlur={handleBlur}
                                  handleChange={handleChange}
                                  values={values}
                                  setFieldValue={setFieldValue}
                                  setValues={setValues}
                                  errors={errors}
                                  touched={touched}
                                />
                                <div className="text-right mt-3">
                                  <Button
                                    variant="outline-primary"
                                    className="me-2"
                                    onClick={() => setFormEndereco(false)}
                                    disabled={isSubmitting}
                                  >
                                    Cancelar
                                  </Button>
                                  &nbsp;
                                  <Button
                                    variant="primary"
                                    onClick={handleSubmit}
                                    disabled={isSubmitting}
                                  >
                                    {isSubmitting ? 'Salvando...' : 'Salvar'}
                                  </Button>
                                </div>
                              </>
                            )}
                          </Formik>
                        </div>
                      )}
                      {isRespondido && (
                        <ul className="list-unstyled d-flex flex-wrap produtividade text-md-left df-center mt-3">
                          <li>
                            <small className="d-block">Enviado por</small>
                            <strong className="d-block text-muted">
                              {dadosDaVenda.nome_usuario_envio_formulario}
                            </strong>
                          </li>
                          <li>
                            <small className="d-block">Enviado em</small>
                            <strong className="d-block text-muted">
                              {format.datetime(
                                dadosDaVenda.data_envio_formulario
                              )}
                            </strong>
                          </li>
                        </ul>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-md-6 mx-auto">
            <div className="card mt-4 border-0">
              <div className="card-body">
                {dadosDaVenda && questionario && (
                  <div>
                    <Formik onSubmit={salvarPesquisa} initialValues={[]}>
                      {({
                        values,
                        handleSubmit,
                        setFieldValue,
                        isSubmitting,
                        isLoadingOptions,
                      }) => (
                        <Form>
                          <>
                            {questionario.map((pergunta, index) => (
                              <div className="mb-3" key={pergunta.codigo}>
                                {pergunta.codigo === 75 && (
                                  <div>
                                    <hr />
                                    <h5 className="text-center">
                                      Questionário
                                    </h5>
                                    <hr />
                                  </div>
                                )}
                                {pergunta.tipo ===
                                  constants.TIPOS_PESQUISA.ESCOLHA &&
                                  isRespondido &&
                                  mostrarPergunta(pergunta.codigo, values) && (
                                    <>
                                      <label htmlFor={pergunta.codigo}>
                                        {pergunta.descricao_pergunta}
                                      </label>
                                      <Select
                                        isDisabled={true}
                                        value={obterValorPadrao(
                                          pergunta.codigo,
                                          pergunta.tipo
                                        )}
                                      />
                                    </>
                                  )}
                                {pergunta.tipo ===
                                  constants.TIPOS_PESQUISA.ESCOLHA &&
                                  !isRespondido &&
                                  mostrarPergunta(pergunta.codigo, values) && (
                                    <>
                                      <label htmlFor={pergunta.codigo}>
                                        {pergunta.descricao_pergunta}
                                      </label>
                                      <Select
                                        noOptionsMessage={() =>
                                          'Nenhuma resposta encontrada'
                                        }
                                        isDisabled={
                                          isLoadingOptions || isSubmitting
                                        }
                                        placeholder="Escolha uma resposta..."
                                        options={pergunta.respostas.map(
                                          ({ codigo, descricao_resposta }) => ({
                                            value: codigo,
                                            label: descricao_resposta,
                                          })
                                        )}
                                        onChange={resposta =>
                                          setFieldValue(
                                            pergunta.codigo,
                                            resposta.value
                                          )
                                        }
                                        defaultValue={obterValorPadrao(
                                          pergunta.codigo,
                                          pergunta.tipo
                                        )}
                                      />
                                    </>
                                  )}

                                {pergunta.tipo ===
                                  constants.TIPOS_PESQUISA.PESO &&
                                  mostrarPergunta(pergunta.codigo, values) && (
                                    <EscalaSatisfacao
                                      name={`pergunta.${index}`}
                                      disabled={isSubmitting || isRespondido}
                                      value={values[pergunta.codigo]}
                                      label={pergunta.descricao_pergunta}
                                      onChange={resposta =>
                                        setFieldValue(
                                          pergunta.codigo,
                                          parseInt(resposta)
                                        )
                                      }
                                      defaultValue={obterValorPadrao(
                                        pergunta.codigo,
                                        pergunta.tipo
                                      )}
                                    />
                                  )}
                                {pergunta.tipo ===
                                  constants.TIPOS_PESQUISA.DISSERTATIVA &&
                                  mostrarPergunta(pergunta.codigo, values) && (
                                    <>
                                      <label htmlFor={pergunta.codigo}>
                                        {pergunta.descricao_pergunta}
                                      </label>
                                      <textarea
                                        className="form-control"
                                        id={pergunta.codigo}
                                        rows="3"
                                        onChange={resposta =>
                                          setFieldValue(
                                            pergunta.codigo,
                                            resposta.target.value
                                          )
                                        }
                                        disabled={isRespondido}
                                        defaultValue={obterValorPadrao(
                                          pergunta.codigo,
                                          pergunta.tipo
                                        )}
                                      />
                                    </>
                                  )}
                              </div>
                            ))}
                            <hr />
                            <div className="mt-3">
                              {!dadosDaVenda.endereco_confirmado && (
                                <span className="text-danger">
                                  Para prosseguir com o envio, é necessário
                                  confirmar o endereço do cliente.
                                </span>
                              )}
                              <button
                                className="btn btn-primary btn-lg m-auto d-flex align-items-center"
                                type="button"
                                onClick={handleSubmit}
                                disabled={
                                  isSubmitting ||
                                  isRespondido ||
                                  !dadosDaVenda.endereco_confirmado
                                }
                              >
                                <ClipLoader
                                  css={css`
                                    margin-right: 10px;
                                  `}
                                  sizeUnit={'px'}
                                  size={20}
                                  color={'#fff'}
                                  loading={isSubmitting}
                                />
                                {isSubmitting
                                  ? 'Enviando...'
                                  : 'Enviar pesquisa'}
                              </button>
                            </div>
                          </>
                        </Form>
                      )}
                    </Formik>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
